import { render, staticRenderFns } from "./PercentualCell.vue?vue&type=template&id=8b1d174e&scoped=true"
import script from "./PercentualCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./PercentualCell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PercentualCell.vue?vue&type=style&index=0&id=8b1d174e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1d174e",
  null
  
)

export default component.exports